import React, { FC } from 'react';

import ProgressRing from '@adsk/alloy-react-progress-ring';

import EntityPickerModalEmptyState from './EntityPickerModalEmptyState';
import EntityPickerModalError from './EntityPickerModalError';
import EntityPickerModalNoSearchResults from './EntityPickerModalNoSearchResults';
import { CommonReferencePickerPlugin } from '../types/ReferencePickerPlugin';
import { PluginQueryFilters } from '../types/types';

interface EntityPickerModalNoDataProps {
  plugin: CommonReferencePickerPlugin;
  loading?: boolean;
  error?: boolean | object;
  onTryAgain: () => void;
  filters: PluginQueryFilters;
  setFilters: (filters: PluginQueryFilters) => void;
  canCreate: boolean;
  onCreateClick: () => void;
  dataViewProps?: object;
}

const DefaultLoader = () => <ProgressRing size={ProgressRing.SIZES.MEDIUM} />;

const EntityPickerModalNoData: FC<EntityPickerModalNoDataProps> = ({
  plugin,
  loading,
  error,
  onTryAgain,
  filters,
  setFilters,
  canCreate,
  onCreateClick,
  dataViewProps,
}) => {
  if (loading) {
    const Loader = plugin.CustomPickerEmptyLoader || DefaultLoader;
    return <Loader />;
  }
  if (error) {
    const ErrorComponent = plugin.CustomPickerError || EntityPickerModalError;
    return (
      <ErrorComponent
        error={!!error}
        onTryAgain={onTryAgain}
        dataViewProps={dataViewProps}
      />
    );
  }
  if (filters && Object.keys(filters).length) {
    const NoResults =
      plugin.CustomPickerNoSearchResults || EntityPickerModalNoSearchResults;
    return (
      <NoResults
        clearFilters={() => setFilters && setFilters({})}
        setFilters={setFilters}
        filters={filters}
        dataViewProps={dataViewProps}
      />
    );
  }
  const NoData = plugin.CustomPickerEmptyState || EntityPickerModalEmptyState;
  return (
    <NoData
      onCreateClick={onCreateClick}
      canCreate={canCreate}
      plugin={plugin}
      dataViewProps={dataViewProps}
    />
  );
};

export default EntityPickerModalNoData;
